/**
 * Cuerpos por defecto de las plantillas de aviso de envío, por idioma.
 *
 * Se usan como respaldo local cuando `GET /accounts/{acc}/template-variables` no
 * devuelve `contentExample` para SHIPPING_UPDATE — que hoy es siempre, porque el
 * backend no tiene ninguna fila de TemplateVariables registrada para este flowType
 * (comprobado en producción: responde 200 con cuerpo vacío). Sin este respaldo el
 * editor abriría en blanco.
 *
 * Reglas de Meta que estos textos cumplen y que hay que respetar al tocarlos:
 *  - Categoría UTILITY: cero contenido promocional. Un solo "y llévate un 10 %"
 *    recategoriza la plantilla a MARKETING (⅓ de conversación en vez de ¼).
 *  - El cuerpo NO puede empezar ni acabar con una variable: rechazo automático.
 *    Por eso ninguno termina en {{tracking_url}}; siempre cierra una frase.
 *  - Español de Argentina con voseo, como ya hacen las bodegas argentinas en sus
 *    plantillas de agradecimiento.
 */

const DEFAULT_TEMPLATES = {
    es:
        'Hola {{customer_first_name}}, soy {{agent_name}} de {{business_name}}.\n\n' +
        'Tu pedido {{order_number}} ya está {{shipping_status}}.\n\n' +
        'Transportista: {{tracking_company}}\n' +
        'Número de seguimiento: {{tracking_number}}\n\n' +
        'Si necesitas cualquier cosa, respóndeme por aquí.',

    en:
        'Hi {{customer_first_name}}, this is {{agent_name}} from {{business_name}}.\n\n' +
        'Your order {{order_number}} is now {{shipping_status}}.\n\n' +
        'Carrier: {{tracking_company}}\n' +
        'Tracking number: {{tracking_number}}\n\n' +
        'Just reply here if you need anything.',

    es_ES:
        'Hola {{customer_first_name}}, soy {{agent_name}} de {{business_name}}.\n\n' +
        'Tu pedido {{order_number}} ya está {{shipping_status}}.\n\n' +
        'Transportista: {{tracking_company}}\n' +
        'Número de seguimiento: {{tracking_number}}\n\n' +
        'Si necesitas cualquier cosa, respóndeme por aquí.',

    es_AR:
        'Hola {{customer_first_name}}, soy {{agent_name}} de {{business_name}}.\n\n' +
        'Tu pedido {{order_number}} ya está {{shipping_status}}.\n\n' +
        'Transportista: {{tracking_company}}\n' +
        'Número de seguimiento: {{tracking_number}}\n\n' +
        'Si necesitás algo, escribime por acá.',
};

/**
 * Devuelve el cuerpo por defecto para un idioma, con cascada exacto → base → en.
 *
 * @param {string} languageTag Tag de idioma (es, en, es_ES, es_AR…).
 * @returns {string} Cuerpo por defecto. Nunca vacío.
 */
export const getDefaultShippingTemplate = (languageTag) => {
    if (!languageTag) return DEFAULT_TEMPLATES.en;

    const exact = DEFAULT_TEMPLATES[languageTag];
    if (exact) return exact;

    const [base] = String(languageTag).split('_');
    return DEFAULT_TEMPLATES[base.toLowerCase()] || DEFAULT_TEMPLATES.en;
};

export default DEFAULT_TEMPLATES;
